import React from 'react';
import Aside from './Aside.js';
import { Route, Switch } from 'react-router-dom';
import Dashboard from './../DashBoard/main';
import Settings from './../Settings/main.js'
import Client from './../Client/main.js'
import ClientCreate from './../Client/Create'
import ClientDetails from './../Client/OneClient'
import TopBarAdmin from './TopBar'

function Layout({ setLocale }) {	
	return (
		<>
			<TopBarAdmin /> 
			<div className={`app`} >
				<Aside/>
				<Switch>
					{/* redirect to dashboard after login */}
					
					<Route exact path="/Admin/dashboard">
						<Dashboard />
					</Route>

					<Route exact path="/Admin/client">
						<Client />
					</Route>

                    <Route exact path="/Admin/client/create">
						<ClientCreate />
					</Route>

                    <Route exact path="/Admin/client/:id">
						<ClientDetails />
					</Route> 
					         
					<Route exact path="/Admin/settings">
						<Settings/>
					</Route>        
				</Switch>
			</div>
		</>
	);
}

export default Layout;
